<div class="delete-container">
  <div class="delete-option">
    <h1>Delete User</h1>
    <label for="email">Email or Phone</label>
    <input
      type="search"
      class="form-control"
      placeholder="Email/Phone"
      autocomplete="off"
      email
      required
      #userInfo
    />

    <button class="btn btn-yellow btn-sm findUser" (click)="findUser(userInfo.value)">
      Find User
    </button>
  </div>
</div>
